module.exports = __webpack_public_path__ + "img/client-time-attack.13e95119.png";